<template>
  <div>
    <!-- Filters -->
    <Filters :elements="filterElements" @selectedFilters="selectedFilters" />

    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="pushDetail"
      detailUrl="/services/streaming"
      :moduleName="`servers.streaming`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
      :moduleSearch="search"
    >
      <template v-slot:item.started_at="{ item }">
        {{
          $customFunctions.setMomentWithFormat(
            item.started_at,
            'ddd MMM DD YYYY HH:mm:ss'
          )
        }}
      </template>

      <template v-slot:item.status="{ item }">
        <Label :class="item.status.toLowerCase()">{{
          $t(`filters.${item.status.toLowerCase()}`)
        }}</Label>
      </template>

      <template v-slot:item.action="{ item }">
        <ActionButton
          icon="fas fa-pencil"
          :title="$t('global.update')"
          @click.native="openForUpdate(item)"
        ></ActionButton>
        <ActionButton
          icon="fas fa-eye"
          :title="$t('global.openDetail')"
          @click.native="pushDetail(item)"
        ></ActionButton>
        <DeleteButton
          icon="fad fa-trash"
          :title="$t('global.delete')"
          @click.native="openDeleteHandler(item)"
        ></DeleteButton>
      </template>
    </List>
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />

    <!-- Create Popup -->
    <DetailModal
      :title="
        $t(selectedItem == '' ? 'servers.createStream' : 'servers.updateStream')
      "
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <CreateStream
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selectedItem="selectedItem"
      />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'Streaming',
  data() {
    return {
      search: '',
      filters: '',
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        {
          text: 'servers.streamName',
          value: 'name',
          size: '2fr',
          clicked: true,
        },
        { text: 'global.type', value: 'type', clicked: true },
        {
          text: 'servers.streamingDate',
          value: 'started_at',
          size: '2fr',
          clicked: true,
        },
        { text: 'global.status', value: 'status', clicked: true },
        { text: 'global.actions', value: 'action' },
      ],
      data: [],
      pagination: {},
      meta: {},
      filterElements: [
        {
          type: 'dropdown',
          name: 'status',
          value: '',
          items: [
            { name: 'filters.showAll', value: '' },
            { name: 'filters.active', value: 'active' },
            { name: 'filters.scheduled', value: 'scheduled' },
            { name: 'filters.preparing', value: 'preparing' },
            { name: 'filters.configuring', value: 'configuring' },
            { name: 'filters.inactive', value: 'inactive' },
          ],
        },
      ],
      deleteOperationUrl: '',
      selectedItem: '',
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'servers.streaming',
        route: '/services/streaming',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.services',
        },
        {
          title: 'servers.streaming',
          route: '/services/streaming',
        },
      ],
      searchPlaceholder: 'servers.searchForStreams',
      detailPlaceholder: 'servers.createNewStream',
    })

    EventBus.$on(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$on(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$off(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  methods: {
    listenersubHeaderSearch(payload) {
      this.search = payload
      this.getList()
    },
    listenersubHeaderDetailOpen(payload) {
      this.selectedItem = ''
      this.showDetail = payload
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta
      let $query = `streaming/stream?position=id|desc&page=${
        current_page ? current_page : 1
      }`

      if (this.search) $query += `&name=${this.search}`

      if (this.filters) $query += `&${this.filters}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    selectedFilters(value) {
      this.filters = value
      this.getList()
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `streaming/stream/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    openForUpdate(item) {
      this.selectedItem = item
      this.showDetail = true
    },
    pushDetail(item) {
      this.$router.push(`/services/streaming/${item.id}`)
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    CreateStream: () => import('@/components/forms/CreateStream'),
  },
}
</script>
